import script from "./ChallengeOverviewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChallengeOverviewPage.vue?vue&type=script&setup=true&lang=js"

import "./ChallengeOverviewPage.vue?vue&type=style&index=0&id=4e1b48ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e1b48ba"]])

export default __exports__